import { api } from '../../../shared/services/api/client';

export function fetchAdminMerchants(params) {
    return api.get('/admin/merchants', { params });
}

export function fetchAdminMerchant(merchantId) {
    return api.get(`/admin/merchants/${merchantId}`);
}

/** Same analytics payload as merchant dashboard (read-only), plus recent activity. */
export function fetchAdminMerchantDashboard(merchantId, params = {}) {
    return api.get(`/admin/merchants/${merchantId}/dashboard`, { params });
}

export function postAdminMerchantSignupInvite(body) {
    return api.post('/admin/merchant-signup-invites', body);
}

export function deleteAdminMerchant(merchantId, confirmName) {
    return api.delete(`/admin/merchants/${merchantId}`, { data: { confirmName } });
}

/** Download PNG QR for merchant in-store customer signup (LoyalPass admin). */
export function fetchAdminMerchantSignupQr(merchantId) {
    return api.get(`/admin/merchants/${merchantId}/signup-qr`, { responseType: 'blob' });
}

/** Set tier and sync Stripe (cancel subscription or change price when configured). */
export function patchAdminMerchantTier(merchantId, body) {
    return api.patch(`/admin/merchants/${merchantId}/tier`, body);
}
